import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      email: null
    }
  },
  mutations: {
    setUser (state, user) {
      state.user = user;
    }
  },
  actions: {
    setUser ({ commit }, user) {
      if (user.email) commit('setUser', user);
    }
  }
})
